import { API, graphqlOperation } from "aws-amplify";
import { GET_LEARNER_FEEDBACK_INFO, GET_LEARNER_FEEDBACK_FAILURE, GET_LEARNER_FEEDBACK_SUCCESS, TRIGGER_TOAST } from "../constants";
import { getLearnerFeedback } from "../../queries";

const getStoreLearnerFeedbackInfo = (learnerToken : string) => {
  return async (dispatch: any) => {
    dispatch({ type: GET_LEARNER_FEEDBACK_INFO });
    const data = API.graphql(graphqlOperation(getLearnerFeedback(learnerToken))) as Promise<any>;
    await data
      .then((learnerFeedbackData: any) => {        
        if (learnerFeedbackData?.data) {
          dispatch({ type: GET_LEARNER_FEEDBACK_SUCCESS, payload: { ...learnerFeedbackData } });
        } 
      })
      .catch(() => {
        dispatch({ type: GET_LEARNER_FEEDBACK_FAILURE });
        dispatch({
          type: TRIGGER_TOAST,
          payload: {
            shouldShow: true,
            severity : 'error',
            transMessage: "message_errorDefault"
          },
        });
      });
  };
};

export default {
    getStoreLearnerFeedbackInfo,
};
